import NdaStatusBadge from './NdaStatusBadge.component';

export default NdaStatusBadge;
